import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authenticated API - sends/receives auth cookies on every request.
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Legacy admin auth (V1): X-Admin-Token header. Kept for backwards
// compatibility with existing tests and curl scripts. Admin v2 (Phase 7)
// uses an httpOnly cookie via POST /api/admin/login and the shared `api`
// instance above; new admin UI code should NOT use this helper.
export const adminApi = (token) =>
  axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json", "X-Admin-Token": token },
  });

// Map any FastAPI error payload (string | array of {msg} | object) to a single string.
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Friendly form error extractor - collapses an axios error into a single string
// suitable for `toast.error(...)`. Centralises the nested-ternary that used to
// live in every form component.
export function extractFormError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail) return "Please check the form and try again.";
  return fallback;
}
